export enum MuRadioCreditCardType {
  POSTPAID = 'paymentPostpaid',
  PREPAID = 'paymentBalance',
  PREPAID_NEGATIVE = 'paymentBalanceNegative',
  PREPAID_MISSING = 'paymentBalanceMissing',
  EFFECTIVE = 'paymentCash',
  NEW = 'newCard',
  PSE = 'pse',
  TRANSFER_MX = 'transfer_mx',
}
